export default "__VITE_ASSET__1fb0a412__"